<template>
  <v-container>
    <v-row justify="end" align-content="end">
      <v-col align="end">
        <v-btn
          rounded
          dense
          small
          color="primary"
          @click="handleAddLiquidatedDamage"
          :disabled="!canUserEdit"
        >
          <v-icon> mdi-plus </v-icon>
          {{ $t('lds.addLiquidatedDamage') }}
        </v-btn>
      </v-col>
    </v-row>
    <LiquidatedDamagesTable
      :liquidatedDamages="liquidatedDamages"
      :paymentMilestones="paymentMilestones"
      :isMilestoneNameDuplicate="isMilestoneNameDuplicate"
      :contract="contract"
      @SAVE_LD="handleCreateOrUpdateLiquidatedDamage"
      @DELETE_LD="handleDeleteLiquidatedDamage"
      @FINALIZE_LD="handleChangeLiquidatedDamageState"
      @UNLOCK_LD="handleChangeLiquidatedDamageState"
      @SAVE_LD_DATE="handleCreateOrUpdateDate"
      @DELETE_LD_DATE="handleDeleteDate"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { DEFAULT_CONTRACT } from '../helpers'
import { getLiquidatedDamages, createOrUpdateLiquidatedDamage, deleteLiquidatedDamage, createOrUpdateLiquidatedDamageDate, deleteLiquidatedDamageDate, getPaymentMilestones, checkForMilestoneNameDuplicate } from '../services'

export default {
  name: 'LiquidatedDamages',
  props: {
    contract: {
      type: Object,
      default: function () {
        return DEFAULT_CONTRACT
      }
    }
  },
  data () {
    return {
      liquidatedDamages: [],
      paymentMilestones: []
    }
  },
  mounted () {
    if (this.contract.id) {
      this.fetchLiquidatedDamages()
      this.fetchPaymentMilestones()
    }
  },
  computed: {
    ...mapState({
      canUserEdit: state => state.userPermissionsToContract.canUserEdit
    })
  },
  methods: {
    async handleCreateOrUpdateLiquidatedDamage (data) {
      await createOrUpdateLiquidatedDamage(data, this.contract.id)
      this.fetchLiquidatedDamages()
      this.fetchPaymentMilestones()
    },
    async handleChangeLiquidatedDamageState () {
      this.fetchLiquidatedDamages()
      this.fetchPaymentMilestones()
    },
    async handleCreateOrUpdateDate (data) {
      await createOrUpdateLiquidatedDamageDate(data, this.contract.id)
      this.fetchLiquidatedDamages()
    },
    async handleDeleteDate (data) {
      this.$eventBus.$emit('OPEN_CONFIRM_MODAL', {
        options: { maxWidth: 650 },
        scope: {
          message: this.$t('common.deleteConfirm', { name: data.name })
        },
        handlers: {
          yes: async () => {
            await deleteLiquidatedDamageDate(data, this.contract.id)
            this.fetchLiquidatedDamages()
          }
        }
      })
    },
    async handleDeleteLiquidatedDamage (data) {
      this.$eventBus.$emit('OPEN_CONFIRM_MODAL', {
        options: { maxWidth: 650 },
        scope: {
          message: this.$t('common.deleteConfirm', { name: data.name })
        },
        handlers: {
          yes: async () => {
            await deleteLiquidatedDamage(data)
            this.fetchLiquidatedDamages()
          }
        }
      })
    },
    handleAddLiquidatedDamage () {
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'LiquidatedDamagesForm',
        options: { maxWidth: 850 },
        scope: {
          parts: this.contract.parts,
          currencies: this.contract.currencies,
          isMultiCurrency: this.contract.isMultiCurrency,
          isMilestoneNameDuplicate: this.isMilestoneNameDuplicate
        },
        handlers: {
          SAVE_LD: this.handleCreateOrUpdateLiquidatedDamage
        }
      })
    },
    async fetchLiquidatedDamages () {
      this.liquidatedDamages = await getLiquidatedDamages(this.contract.id)
    },
    async fetchPaymentMilestones () {
      this.paymentMilestones = await getPaymentMilestones([], this.contract)
    },
    isMilestoneNameDuplicate (milestoneName, initialName) {
      return checkForMilestoneNameDuplicate(this.liquidatedDamages, this.paymentMilestones, milestoneName, initialName)
    }
  }
}
</script>
